
import { NavItem } from '../types';
import { 
  Activity,
  Shield,
  Package
} from 'lucide-react';

const toolsItems: NavItem[] = [
  {
    title: 'Service Management',
    path: '/app/services',
    icon: Package,
    requiredRoles: ['admin', 'manager'],
    requiredPermissions: ['service.read'],
  },
  {
    title: 'System Health',
    path: '/app/system-health',
    icon: Activity,
    requiredRoles: ['admin'],
    requiredPermissions: ['system.read'],
  },
  {
    title: 'Access Control',
    path: '/app/access-control',
    icon: Shield,
    requiredRoles: ['admin', 'manager'],
    requiredPermissions: ['access_control.read'],
  }
];

export default toolsItems;
